import { css } from '@emotion/react'

// based on  modern-normalize v0.6.0 | MIT License | https://github.com/sindresorhus/modern-normalize
const normalize = t => {
  return css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    html {
      font-size: 100%;
      -webkit-text-size-adjust: 100%;
    }

    body {
      margin: 0;
      font-family: ${t.fonts.body};
      line-height: ${t.lineHeights.body};
      font-weight: ${t.fontWeights.body};
    }

    hr {
      height: 0;
    }

    abbr[title] {
      text-decoration: underline dotted;
    }

    b,
    strong {
      font-weight: bolder;
    }

    code,
    kbd,
    samp,
    pre {
      font-family: ${t.fonts.monospace};
      font-size: 1em;
    }

    small {
      font-size: 80%;
    }

    sub,
    sup {
      font-size: 75%;
      line-height: 0;
      position: relative;
      vertical-align: baseline;
    }

    sub {
      bottom: -0.25em;
    }

    sup {
      top: -0.5em;
    }

    button,
    input,
    optgroup,
    select,
    textarea {
      font-family: inherit;
      font-size: 100%;
      line-height: inherit;
      margin: 0;
    }

    button,
    select {
      text-transform: none;
    }

    button,
    [type='button'],
    [type='reset'],
    [type='submit'] {
      -webkit-appearance: button;
    }

    button::-moz-focus-inner,
    [type='button']::-moz-focus-inner,
    [type='reset']::-moz-focus-inner,
    [type='submit']::-moz-focus-inner {
      border-style: none;
      padding: 0;
    }

    button:-moz-focusring,
    [type='button']:-moz-focusring,
    [type='reset']:-moz-focusring,
    [type='submit']:-moz-focusring {
      outline: 1px dotted ButtonText;
    }

    fieldset {
      padding: 0.35em 0.75em 0.625em;
    }

    legend {
      padding: 0;
    }

    progress {
      vertical-align: baseline;
    }

    [type='number']::-webkit-inner-spin-button,
    [type='number']::-webkit-outer-spin-button {
      height: auto;
    }

    [type='search'] {
      -webkit-appearance: textfield;
      outline-offset: -2px;
    }

    [type='search']::-webkit-search-decoration {
      -webkit-appearance: none;
    }

    ::-webkit-file-upload-button {
      -webkit-appearance: button;
      font: inherit;
    }

    summary {
      display: list-item;
    }

    .visually-hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      border: 0;
      margin: -1px;
      padding: 0;
      white-space: nowrap;
      clip-path: inset(100%);
      clip: rect(0 0 0 0);
      overflow: hidden;
    }
  `
}

export const globalStyles = t => {
  return css`
    ${normalize(t)}

    a {
      text-decoration: none;
    }
  `
}
